import React, { ReactElement } from 'react'
import { useRouter } from 'next/router'
import styled from '@emotion/styled'

import routesConfig from '@mindfulchefuk/config/routesConfig'
import {
  Box,
  Button,
  Grid,
  Image,
  Stack,
  Text,
  theme,
} from '@mindfulchefuk/design-system'
import { ANALYTICS_CATEGORIES } from '@mindfulchefuk/constants'
import { logEvent } from '@mindfulchefuk/utils/analytics'
import { ReasonToJoin } from './ReasonToJoin'

const BannerImage = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 100%;
`

export const ReasonsToJoinBanner = (): ReactElement => {
  const router = useRouter()

  const handleClick = () => {
    logEvent({
      category: ANALYTICS_CATEGORIES.recipeLibrary,
      action: 'Recipe Page',
      label: 'Bottom of the Page CTA Clicked',
    })
    return router.push(
      routesConfig.chooseRecipes.pathname,
      routesConfig.chooseRecipes.as
    )
  }

  return (
    <Grid
      bg={theme.colors['aubergine-50']}
      templateColumns={{ base: '1fr', sm: '249px 433px' }}
      my={{ md: 40 }}
      maxWidth={{ base: '100%', md: 768 }}
    >
      <BannerImage
        resolve
        src="choose-recipes/recipe-page-reasons-to-join-banner.png"
      />
      <Box p={24} textAlign="left">
        <Text variant="heading-md">Getting hungry?</Text>
        <Text variant="body-md" marginY={16}>
          Find 48 recipes a week just like this one at Mindful Chef, that are
          all:
        </Text>
        <Stack color="aubergine" spacing={16} mb={24}>
          <ReasonToJoin
            icon="heart"
            text="Delicious, high quality food - and lots of it"
          />
          <ReasonToJoin
            icon="gluten-free"
            text="No stodgy refined carbs - no food comas here"
          />
          <ReasonToJoin
            icon="soil"
            text="Goodness from natural food - full of fibre"
          />
        </Stack>

        <Button variant="primary" size="small" onClick={handleClick}>
          Explore this week&apos;s menu
        </Button>
      </Box>
    </Grid>
  )
}
